module.exports = __webpack_public_path__ + "media/images/icon-carrot-right-bad6c8f880b014f4b5210281a3fe26b3.svg";